import { Anchor, Box, Image, Text } from '@mantine/core'
import { RichTextEditor } from 'components/text/rich-text-editor'
import { useTranslation } from 'react-i18next'
import type { Tradeshow } from 'api/dto/tradeshow'

interface EventInfoProps {
  tradeshow: Tradeshow
  isSmallDevice: boolean
  currentLanguage: string
}

export function EventInfo({ tradeshow, isSmallDevice, currentLanguage }: EventInfoProps) {
  const { t } = useTranslation()

  return (
    <>
      {/* Event Logo */}
      {tradeshow.config.logo && (
        <Box sx={{ textAlign: 'center', marginBottom: 24 }}>
          <Image maw={200} mx="auto" src={tradeshow.config.logo} alt={tradeshow.name} />
        </Box>
      )}

      {/* Event Title */}
      <Box sx={{ textAlign: 'center', marginBottom: 32 }}>
        <Text
          sx={{
            fontSize: isSmallDevice ? 28 : 36,
            fontWeight: 800,
            color: '#111827',
            letterSpacing: '-0.02em',
            lineHeight: 1.2,
          }}
        >
          {tradeshow.name}
        </Text>

        {tradeshow.config.scheduleLink && tradeshow.config.scheduleLink.url && (
          <Anchor
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              marginTop: 12,
              color: '#850014',
              fontWeight: 500,
              fontSize: 15,
              '&:hover': { textDecoration: 'underline' },
            }}
            href={tradeshow.config.scheduleLink.url}
            target="_blank"
          >
            {currentLanguage === 'fr' ? tradeshow.config.scheduleLink.fr : tradeshow.config.scheduleLink.en}
          </Anchor>
        )}
      </Box>

      {/* Description */}
      {tradeshow.description && (
        <Box sx={{ marginBottom: 32 }}>
          <RichTextEditor editable={false} content={tradeshow.description} />
        </Box>
      )}

      {/* Sponsor Logo */}
      {tradeshow.config.sponsorLogo && (
        <Box sx={{ textAlign: 'center', marginBottom: 40 }}>
          <Text size="sm" color="dimmed" weight={500} mb={12}>
            {t('register.our-sponsors')}
          </Text>
          <Image maw={500} mx="auto" src={tradeshow.config.sponsorLogo} />
        </Box>
      )}
    </>
  )
}
